import React from 'react'

import joinGame from '../../actions/joinGame'
import {
  Page,
  H1,
  Input,
  Button,
} from '../styles'

class Join extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      inputValue: '',
    }
  }

  _handleInput = (event) => {
    this.setState({
      inputValue: event.target.value,
    })
  }

  _handleSubmit = (event) => {
    joinGame(this.state.inputValue)
  }

  render() {
    return <Page>
      <H1>Join a game</H1>
      <p>Enter the game code here (ask the person who started the game)</p>
      <Input autoFocus value={this.state.inputValue} onChange={this._handleInput} />
      <Button primary onClick={this._handleSubmit} disabled={this.state.inputValue.length < 1}>Join game</Button>
    </Page>
  }

}

export default Join



// WEBPACK FOOTER //
// ./src/views/lobby/Join.jsx